var TypingIndicatorType;
(function (TypingIndicatorType) {
    TypingIndicatorType["Text"] = "text";
    TypingIndicatorType["Bubble"] = "bubble";
})(TypingIndicatorType || (TypingIndicatorType = {}));

export { TypingIndicatorType as T };
//# sourceMappingURL=bundle-qcluyCmu.js.map
